import angular from "angular";

const NotEmptyDirective = function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, elm, attrs, ngModel: ng.INgModelController) {
            ngModel.$validators.notEmpty = function (modelValue) {
                return angular.isArray(modelValue) && modelValue.length > 0;
            };

            scope.$watchCollection(attrs.ngModel, function () {
                ngModel.$validate();
            })
        }
    }
};

export { NotEmptyDirective };